

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Divider,
  Select,
  MenuItem,
  Card,
  CardContent,
  SvgIcon,
} from "@mui/material";
import Shop from "../../../src/assests/images/shop.svg";
import Note from "../../../src/assests/images/note.svg";
import Location from "../../../src/assests/images/location.svg";
import { getalllocations, getfilterdata1 } from "./api";
import { dashboardPendingTask } from "./api";
import { getToken } from "../../utils/utils";

interface User {

  id: number;
  fullName: string;
  outlet_name: string;
  location: string;
  total_points: string;
  redeemed_points: string;
  total_tasks: number;
  last_login_time: string;
  last_login: string;

  task_id: number;

  task_name: string;

  reassign_count: string;

  task_status: string;


}
const LineArrow = () => (
  <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: "30px" }}>
    <path
      d="M7 10l5 5 5-5"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
// export default function TaskPending() {
  interface TaskPendingProps {
    dropdownValue: string;
    setDropdownValue: React.Dispatch<React.SetStateAction<string>>;
    dropdownValue1: string;
    setDropdownValue1: React.Dispatch<React.SetStateAction<string>>;
    users: User[];
  setUsers: React.Dispatch<React.SetStateAction<User[]>>;

  }

  
  
  export default function TaskPending({
    dropdownValue,
    setDropdownValue,
    dropdownValue1,
    setDropdownValue1,
    users,
    setUsers
  }: TaskPendingProps) {
  // const [users, setUsers] = useState<User[]>([]);

  const [showAll, setShowAll] = useState(false);
  // const users = [
  //   {
  //     name: "Amit Kumar",
  //     shop: "Amit Paan Shop",
  //     location: "Delhi",
  //     status: "Opened",
  //     taskName: "Click picture of Marlboro Gold...",
  //     reassignCount: 3,
  //     tasksubName: "Task Name",
  //   },
  //   {
  //     name: "Sumit Singh",
  //     shop: "SS Paan Shop",
  //     location: "Delhi",
  //     status: "Not Started",
  //     taskName: "Know our Product",
  //     reassignCount: 0,
  //     tasksubName: "Task Name",
  //   },
  //   {
  //     name: "Deven Pratap",
  //     shop: "Raj Paan Shop",
  //     location: "Mumbai",
  //     status: "Opened",
  //     taskName: "Build your stick",
  //     reassignCount: 1,
  //     tasksubName: "Task Name",
  //   },
  //   {
  //     name: "Deven Pratap",
  //     shop: "Raj Paan Shop",
  //     location: "Mumbai",
  //     status: "Opened",
  //     taskName: "Build your stick",
  //     reassignCount: 1,
  //     tasksubName: "Task Name",
  //   },
  //   {
  //     name: "Deven Pratap",
  //     shop: "Raj Paan Shop",
  //     location: "Mumbai",
  //     status: "Opened",
  //     taskName: "Build your stick",
  //     reassignCount: 1,
  //     tasksubName: "Task Name",
  //   },
  //   {
  //     name: "Deven Pratap",
  //     shop: "Raj Paan Shop",
  //     location: "Mumbai",
  //     status: "Opened",
  //     taskName: "Build your stick",
  //     reassignCount: 1,
  //     tasksubName: "Task Name",
  //   },
  // ];
  // const [showAll, setShowAll] = React.useState(false);

  const visibleUsers = showAll ? users : users.slice(0, 5);
console.log(showAll, "showAll55555555555555555555555555554")
  // const [dropdownValue, setDropdownValue] = React.useState("");
  // const [dropdownValue1, setDropdownValue1] = React.useState("");

  const [allcities, setcities] = React.useState([]);
  const [selectedLocation, setSelectedLocation] = useState<string[]>([]);



  useEffect(() => {

    const fetchDropdownCities = async () => {
      try {
        const response = await getalllocations();
        console.log(response, "API Response");

        const cities = response.data.data;
        console.log(cities, "Cities Data");

        console.log(cities, "locationslocationslocations")
        setcities(cities)

      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchDropdownCities();

  }, []);
  const token = getToken();
  const [filters, setFilters] = useState<Array<any>>([])

  useEffect(() => {
    getfilterdata1(token).then((res) => {
      if (res.status) {
        console.log(res.data.data, "resdata")
        setFilters(res?.data?.data || [])
      }
    })
  }, [])



  const handleDropdownChange = (event: any) => {
    setDropdownValue(event.target.value);
  };


  const handleDropdownChange1 = (event: any) => {
    setDropdownValue1(event.target.value);
  };

  console.log(dropdownValue1, "dropdownValue1ddddddddddd",dropdownValue, "llllllllllllll" )
console.log(visibleUsers, "usersaaaaaaaawwwwwwwwwwww")



  return (
    <Box
      sx={{
        borderRadius: "8px",
        padding: "0px",
        backgroundColor: "#fff",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        border: "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "50%", padding: "0px" }}>
          <Select
            value={dropdownValue1 || "All Tasks"}
            onChange={handleDropdownChange1}
            sx={{ maxWidth: "230px", height: "40px" }}
            defaultValue="All Tasks"
            fullWidth
            IconComponent={LineArrow}
          >

            <MenuItem value="All Tasks">All Tasks</MenuItem>
            {filters
              .filter((item) => item.category === "Tasks")
              .flatMap((item) =>
                item.options
                  .filter((ee: any) => ee.label !== "All")
                  .map((ee: any) => (
                    <MenuItem key={ee.id} value={ee.id}>
                      {ee.label}
                    </MenuItem>
                  ))
              )}
          </Select>
        </Box>
        <Box sx={{ width: "50%", paddingLeft: "8px" }}>
          <Select
            value={dropdownValue || 'All Locations'}
            onChange={handleDropdownChange}
            sx={{ maxWidth: "230px", height: "40px" }}
            defaultValue="All Locations"
            fullWidth
            IconComponent={LineArrow}
          >
            <MenuItem value="All Locations">All Locations</MenuItem>
            {allcities.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
      <Divider sx={{ marginY: "16px" }} />
      {users.map((user, index) => (
        <Card
          key={index}
          sx={{
            marginBottom: "16px",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            backgroundColor: "##E7E8E9 ",
            boxShadow: "none",
            padding: "0",
          }}
        >
          <CardContent>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={8}>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  sx={{ fontSize: "18px", color: "#282829" }}
                >
                  {user.fullName}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontSize: "14px", color: "#7D7E7F", display: "flex" }}
                >
                  <Typography
                    sx={{
                      paddingRight: "15px",
                      position: "relative",
                      "&:before": {
                        content: '"|"',
                        display: "inline-block",
                        marginRight: "5px",
                        color: "black",
                        position: "absolute",
                        right: "-5px",
                        top: "2px",
                      },
                    }}
                  >
                    <img
                      style={{
                        paddingRight: "5px",
                        paddingTop: "5px",
                        position: "relative",
                        top: "2px",
                      }}
                      src={Shop}
                      alt="Shop"
                    />

                    {user.outlet_name}
                  </Typography>

                  <Typography sx={{ paddingLeft: "15px" }}>
                    <img
                      style={{
                        paddingRight: "5px",
                        paddingTop: "5px",
                        position: "relative",
                        top: "2px",
                      }}
                      src={Location}
                      alt="Shop"
                    />
                    {user.location}
                  </Typography>
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    marginTop: "15px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  <img src={Note} alt="Note" style={{ marginRight: "5px" }} />{" "}
                  {user.task_name}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#7D7E7F",
                    paddingLeft: "25px",
                  }}
                >
                  {user.task_name}                </Typography>
              </Grid>
              <Grid item xs={4} textAlign="right">
                <Button
                  size="small"
                  sx={{
                    backgroundColor:
                      user.task_status === "Opened" ? "#FBF3E0" : "#F1F2F3",
                    color: user.task_status === "Opened" ? "#CA8501" : "#696A6B",
                    fontWeight: "bold",
                    borderRadius: "16px",
                    textTransform: "capitalize",
                    padding: "4px 12px",
                  }}
                >
                  {user.task_status}
                </Button>
                <Typography
                  variant="body2"
                  sx={{
                    marginTop: "8px",
                    fontSize: "12px",
                    color: "#7D7E7F",
                  }}
                >
                  <Typography
                    sx={{
                      width: "100%",
                      fontSize: "14px",
                      color: "#494A4B",
                      fontWeight: "600",
                      marginTop: "30px",
                    }}
                  >
                    {user.reassign_count}
                  </Typography>
                  Reassign Count:
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ))}
      {users.length > 5 && (
        <Button
          onClick={() => setShowAll(!showAll)}
          sx={{
            width: "100%",
            marginTop: "16px",
            textTransform: "capitalize",
            color: "#C8172F",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          {showAll ? "Show Less" : "View All"}
        </Button>
      )}
    </Box>
  );
}



